/**
 * app/View/Components/YearSelectComponent.php
 * resources/admin/js/year-select-component.js
 * resources/shared/sass/components/year-select-component.scss
 * resources/views/components/year-select-component.blade.php
 */

$(document).ready(() => {
    /**
     * Select all year select button to add the functionality
     */
    $('ul.yearSelectComponentContainer').each(function () {
        let ulYearSelectComponent = $(this);
        $('li.year-select-year', ulYearSelectComponent).each(function () {
            let li = $(this);
            let btn = $('button', li);
            li.off('click keydown').on('click keydown', function () {
                let year = btn.attr('data-year');
                fnyearSelectComponent(ulYearSelectComponent, year);
            });
        });
    });

    $('select#calendarYearPrices').off('change').on('change', function (event) {
        event.preventDefault();
        let year = $(this).val();
        let url = document.location.pathname + '?year=' + year + document.location.hash;
        document.location = url;
        return false;
    });

    /**
     * @param year
     */
    fnyearSelectComponent = (ulYearSelectComponent, year) => {
        // Check if the current year is clicked.
        let currentSelected = null;
        if ($('li.year-select-year.active button', ulYearSelectComponent).length > 0) {
            if (parseInt(year) === parseInt($('li.year-select-year.active button', ulYearSelectComponent).first().attr('data-year'))) {
                return;
            }
        }


        // Add or remove the active class from the buttons.
        $('li.year-select-year', ulYearSelectComponent).each(function () {
            let li = $(this);
            let btn = $('button', li);
            btn.off('click keydown');
            btn.css('cursor', 'wait');
            if (parseInt(btn.attr('data-year')) === parseInt(year)) {
                btn.parent().addClass('active');

                // Refresh the page with the GET-year parameter changed to the new year.
                let url = document.location.pathname + '?year=' + year + document.location.hash;
                document.location = url;
            } else {
                btn.parent().removeClass('active');
            }

        });

        // Reference for backward compatibility. Probably not used.
        $('#calendarYearPrices').val(year);
    }
});
